import React, { Component, Fragment } from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom'
import { create } from 'jss';
import rtl from 'jss-rtl';
import JssProvider from 'react-jss/lib/JssProvider';
import { MuiThemeProvider, createMuiTheme, createGenerateClassName, jssPreset } from '@material-ui/core/styles';
import indigo from '@material-ui/core/colors/indigo';
import red from '@material-ui/core/colors/red';

import AppContext from './AppContext';
import Dashboard from '../../containers/Dashboard';
import Profile from '../../components/Users/Profile'
import EnquiryPage from '../../components/Enquiries/EnquiryPage'
import OfficePage from '../../components/Offices/OfficePage'
import UserPage from '../../components/Users/UserPage'
import LoadingPage from '../../components/Authentication/LoadingPage'
import { NotFound, NotAllowed, BackendError, Signin, SignUp, ForgotPassword, ResetPassword } from '../../components';

import { connect } from 'react-redux'
import { handleInitialData } from '../../actions/shared'

import * as API from '../../utils/api'

const jss = create({ plugins: [...jssPreset().plugins, rtl()] });
const generateClassName = createGenerateClassName();

class AppProvider extends Component {
  state = {
    type: 'light',
    direction: 'ltr',
    localAuth: false
  }

  componentDidMount () {
    const { dispatch } = this.props
    const authedUserId = localStorage.getItem('authedUserId')

    if (authedUserId) {
      API.getUserByHashId(authedUserId)
      .then(function (response) {
        //console.log(response);

        if (response) {
          dispatch(handleInitialData(authedUserId))
        }
      })
    }
  }

  componentDidUpdate () {
    const localAuth = localStorage.getItem('authedUserId')

    if (!localAuth && this.state.localAuth === true) {
      //console.log('update state')
      this.setState({ localAuth: false })
    }
  }

  render() {
    const { direction, type, localAuth } = this.state
    const { auth, loading, isAdmin } = this.props

    const theme = createMuiTheme({
      direction,
      palette: {
        type,
        primary: indigo,
        secondary: red,
        error: red
      },
      typography: {
        fontFamily: 'Roboto,"Helvetica Neue",Arial,sans-serif',
        headline: {
          fontSize: '1rem',
        },
        subheading: {
          fontSize: '0.8125rem',
        },
        button: {
          fontWeight: 400,
          textTransform: 'initial'
        }
      },
      shape: {
        borderRadius: 4
      }
    });

    return (
      <JssProvider jss={jss} generateClassName={generateClassName}>
        <MuiThemeProvider theme={theme}>
          <AppContext.Provider value={{
            state: this.state,
            toggleTheme: () => this.setState({
              type: this.state.type === 'light' ? 'dark' : 'light'
            }),
            toggleDirection: () => this.setState({
              direction: this.state.direction === 'ltr' ? 'rtl' : 'ltr',
            }, () => document.body.dir = this.state.direction)
          }}>

            <BrowserRouter>
              <Switch>
                {auth || localAuth
                  ? loading
                    ? <Fragment>
                        <LoadingPage />
                      </Fragment>
                    : <Fragment>
                        <Route exact path="/404" component={NotFound} />
                        <Route exact path="/500" component={BackendError} />
                        <Route exact path="/register" component={SignUp} />
                        <Route exact path="/forgot" component={ForgotPassword} />
                        <Route exact path="/reset/:hashId" component={ResetPassword} />
                        <Route exact path="/profile" component={Profile} />
                        <Route exact path="/enquiries" component={Dashboard} />
                        <Route exact path='/enquiry/:id' component={EnquiryPage} />
                        <Route exact path="/offices" component={Dashboard} />
                        <Route exact path='/office/:id' component={OfficePage} />
                        <Route exact path="/users" component={isAdmin ? Dashboard : NotAllowed} />
                        <Route exact path='/user/:id' component={isAdmin ? UserPage : NotAllowed} />
                        <Route exact path="/" component={Dashboard} />
                      </Fragment>
                  : <Fragment>
                      <Route exact path="/404" component={NotFound} />
                      <Route exact path="/500" component={BackendError} />
                      <Route exact path="/register" component={SignUp} />
                      <Route exact path="/forgot" component={ForgotPassword} />
                      <Route exact path="/reset/:hashId" component={ResetPassword} />
                      <Route exact path="/profile" component={Signin} />
                      <Route exact path="/enquiries" component={Signin} />
                      <Route exact path='/enquiry/:id' component={Signin} />
                      <Route exact path="/offices" component={Signin} />
                      <Route exact path='/office/:id' component={Signin} />
                      <Route exact path="/users" component={Signin} />
                      <Route exact path='/user/:id' component={Signin} />
                      <Route exact path="/" component={Signin} />
                    </Fragment>}
              </Switch>
            </BrowserRouter>
          </AppContext.Provider>
        </MuiThemeProvider>
      </JssProvider>
    )
  }
}

function mapStateToProps ({ authedUser, enquiries, offices }) {
  return {
    loading: authedUser === null,
    auth: authedUser !== null,
    isAdmin: authedUser !== null ? authedUser.isAdmin : false
  }
}

export default connect(mapStateToProps)(AppProvider)


// WEBPACK FOOTER //
// ./src/components/AppProvider/AppProvider.js